import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { ExistInventarioComponent } from './exist-inventario/exist-inventario.component';
import { ExistInventarioFisicoComponent } from './exist-inventario-fisico/exist-inventario-fisico.component';
import { ExistDocElectronicosComponent } from './exist-doc-electronicos/exist-doc-electronicos.component';
import { ExistCalcPedidoComponent } from './exist-calc-pedido/exist-calc-pedido.component';
import { ModalAddMovimientoComponent } from './exist-inventario/modal-add-movimiento/modal-add-movimiento.component';
import { ModalViewMovimientoComponent } from './exist-inventario/modal-view-movimiento/modal-view-movimiento.component';
import { ExistInventarioFisicoModalAddEditComponent } from './exist-inventario-fisico/modal-add-edit/modal-add-edit.component';
import { ExistInventarioFisicoModalConsultaComponent } from './exist-inventario-fisico/modal-consulta/modal-consulta.component';
import { ExistInventarioFisicoModalTomaInventarioComponent } from './exist-inventario-fisico/modal-toma-inventario/modal-toma-inventario.component';
import { ExistInventarioFisicoModalRealizarAjusteComponent } from './exist-inventario-fisico/modal-realizar-ajuste/modal-realizar-ajuste.component';
import { ExistInventarioFisicoModalEditarAjusteComponent } from './exist-inventario-fisico/modal-edit-ajuste/modal-editar-ajuste.component';
// elementos usados en scroll infinito
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [
    ExistInventarioComponent,
    ExistInventarioFisicoComponent,
    ExistDocElectronicosComponent,
    ExistCalcPedidoComponent,
    ModalAddMovimientoComponent,
    ModalViewMovimientoComponent,
    ExistInventarioFisicoModalAddEditComponent,
    ExistInventarioFisicoModalConsultaComponent,
    ExistInventarioFisicoModalTomaInventarioComponent,
    ExistInventarioFisicoModalRealizarAjusteComponent,
    ExistInventarioFisicoModalEditarAjusteComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SharedViewsModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule
  ],
  exports: [
    ExistInventarioComponent,
    ExistInventarioFisicoComponent,
    ExistDocElectronicosComponent,
    ExistCalcPedidoComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class InventarioModule { }
